<script setup lang="ts">
import { radioCva, RadioProps } from '.'

type Props = {
  label?: string
  name?: string
  value?: string
  size?: RadioProps['size']
  variant?: RadioProps['variant']
}
defineProps<Props>()

// state
const model = defineModel<boolean>({ default: false })
</script>

<template>
  <label class="flex cursor-pointer items-center gap-1 leading-none">
    <input
      class="cursor-pointer"
      :class="radioCva({ size, variant })"
      type="radio"
      :checked="model"
      :name
      :value
      @input="model = true"
    />
    <slot>
      {{ label }}
    </slot>
  </label>
</template>
